import { useTranslation } from 'react-i18next';

import ProductTagIcon from '~/assets/icons/ProductTag';

type Props = {
  amount?: string;
  code?: string;
};

export default function DiscountCode({ code, amount }: Props) {
  const { t } = useTranslation();
  if (!code || !amount) return null;

  return (
    <div className="flex max-h-12 w-full justify-center bg-yellow-label/95 p-2 tracking-wide">
      <ProductTagIcon stroke="black" height={15} />
      <div className="text-xs">
        {t('enterCode')} <span className="font-bold">{code}</span> {t('for')}{' '}
        {amount} {t('off')}
      </div>
    </div>
  );
}
